


















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";

const Root = namespace("root");

@Component
export default class FooterFixer extends Vue {
  @Prop({ type: String, default: "" }) customLeft; // 自定义左侧间距
  @Prop({ type: String, default: "" }) customRight; // 自定义右侧间距
  @Prop({ type: String, default: "" }) customClass;
  @Prop({ type: Boolean, default: false }) withDefaultStyle;
  @Prop({ type: Boolean, default: false }) withHorizontalPadding;

  @Root.State isCollapse;

  get positionLeft() {
    // 菜单收起时： 菜单宽度是 56px;
    // 菜单展开时： 菜单宽度死 240px;
    // gt-layout__content 的 paddingLeft 是24px
    if (this.customLeft) {
      return `${this.customLeft}px`;
    } else {
      return `${
        (this.isCollapse ? 56 : 240) + (this.withHorizontalPadding ? 24 : 0)
      }px`;
    }
  }

  get positionRight() {
    // 8px 是内容区滚动条的固定宽度，这里给right 固定加上8px是为了让滚动条始终不被遮盖
    // gt-layout__content 的 paddingRight 是24px
    if (this.customRight) {
      return `${this.customRight}px`;
    } else {
      return `${8 + (this.withHorizontalPadding ? 24 : 0)}px`;
    }
  }
}
